import Vue from "vue";
import Vuex from "vuex";
import { getCredits, getSessions } from "../api/vm";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    credits: {
      hoursForecast: 0,
      totalCreditsForThisMonth: 0,
      usedCreditsThisMonth: 0
    },
    maxConcurrentSessions: 0,
    sessions: [],
    creditInterval: null,
    sessionInterval: null
  },
  mutations: {
    setCurrentUser(state, userObject = {}) {
      state.currentUser = userObject;
    },
    setCredits(state, credits = {}) {
      state.credits = credits;
    },
    setMaxConcurrentSessions(state, maxConcurrentSessions = 0) {
      state.maxConcurrentSessions = maxConcurrentSessions;
    },
    stopCreditPoll(state) {
      const intervalId = state.creditInterval;
      if (intervalId) {
        clearInterval(intervalId);
        state.creditInterval = null;
      }
    },
    startCreditPoll(state, intervalId) {
      state.creditInterval = intervalId;
    },
    setSessions(state, sessions = []) {
      state.sessions = sessions;
    },
    stopSessionPoll(state) {
      const intervalId = state.sessionInterval;
      if (intervalId) {
        clearInterval(intervalId);
        state.sessionInterval = null;
      }
    },
    startSessionPoll(state, intervalId) {
      state.sessionInterval = intervalId;
    }
  },
  actions: {
    async pollCredits(context, interval = 0) {
      context.commit("stopCreditPoll");
      const intervalId = setInterval(() => {
        context.dispatch("fetchCredits");
      }, interval);
      context.commit("startCreditPoll", intervalId);
    },
    async pollSessions(context, interval = 0) {
      context.commit("stopSessionPoll");
      const intervalId = setInterval(() => {
        context.dispatch("fetchSessions");
      }, interval);
      context.commit("startSessionPoll", intervalId);
    },
    async updateSessions(context) {
      context.dispatch("fetchSessions");
    },
    async fetchCredits(context) {
      const res = await getCredits();
      const {
        hoursForecast = 0,
        totalCreditsForThisMonth = 0,
        usedCreditsThisMonth = 0,
        maxConcurrentSessions = 5
      } = res.data ? res.data : {};
      context.commit("setCredits", {
        hoursForecast,
        totalCreditsForThisMonth,
        usedCreditsThisMonth,
        maxConcurrentSessions
      });
    },
    async fetchSessions(context) {
      try {
        const response = await getSessions();
        const {
          sessions = [],
          hoursForecast = 0,
          totalCreditsForThisMonth = 0,
          usedCreditsThisMonth = 0,
          maxConcurrentSessions = 5
        } = response.data ? response.data : {};
        context.commit("setSessions", sessions);
        context.commit("setCredits", {
          hoursForecast,
          totalCreditsForThisMonth,
          usedCreditsThisMonth,
          maxConcurrentSessions
        });
      } catch (error) {
        console.log(error);
      }
    }
  },
  modules: {}
});
